module.exports = ".btn-mob{\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n}\r\n.label-bold{\r\n    font-weight: 600 !important;\r\n}\r\ninput[type=number]::-webkit-inner-spin-button, \r\ninput[type=number]::-webkit-outer-spin-button { \r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    margin: 0; \r\n}\r\n.btn-mob-top{\r\n    width: 100%;\r\n    margin-bottom: 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search/well-details/well-details.component.css
// module id = ./src/app/modules/search/well-details/well-details.component.css
// module chunks = main